import { aiChatMessagesEl } from './dom.js';

let aiChatSmoothScrollRaf: number | null = null;

function cancelAiChatSmoothScroll(): void {
  if (aiChatSmoothScrollRaf) {
    cancelAnimationFrame(aiChatSmoothScrollRaf);
    aiChatSmoothScrollRaf = null;
  }
}

export function scrollAiChatToBottom(): void {
  if (!aiChatMessagesEl) return;
  cancelAiChatSmoothScroll();
  const el = aiChatMessagesEl;
  try {
    const prev = el.style.scrollBehavior;
    el.style.scrollBehavior = 'auto';
    el.scrollTop = el.scrollHeight;
    requestAnimationFrame(function () {
      try {
        el.style.scrollBehavior = prev;
      } catch (_) {}
    });
  } catch (_) {
    aiChatMessagesEl.scrollTop = aiChatMessagesEl.scrollHeight;
  }
}

export function scrollAiChatToBottomSmooth(durMs?: number): void {
  const el = aiChatMessagesEl;
  if (!el) return;
  const scrollEl = el;
  if (typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    try {
      el.style.scrollBehavior = 'auto';
    } catch (_) {}
    el.scrollTop = el.scrollHeight;
    return;
  }
  try {
    el.style.scrollBehavior = 'auto';
  } catch (_) {}
  if (aiChatSmoothScrollRaf) cancelAnimationFrame(aiChatSmoothScrollRaf);
  const start = scrollEl.scrollTop;
  const t0 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
  const dur = typeof durMs === 'number' && durMs > 0 ? durMs : 420;
  const ease = function (t: number): number {
    return 1 - Math.pow(1 - t, 3);
  };
  function frame(now: number): void {
    const target = Math.max(0, scrollEl.scrollHeight - scrollEl.clientHeight);
    const u = Math.min(1, (now - t0) / dur);
    scrollEl.scrollTop = start + (target - start) * ease(u);
    if (u < 1) {
      aiChatSmoothScrollRaf = requestAnimationFrame(frame);
    } else {
      aiChatSmoothScrollRaf = null;
      scrollEl.scrollTop = Math.max(0, scrollEl.scrollHeight - scrollEl.clientHeight);
    }
  }
  aiChatSmoothScrollRaf = requestAnimationFrame(frame);
}
